<template>
    <div class="bo-image-lightbox">
        <div class="image-lightbox-parent">
            <img
                :src="lightboxImage"
                alt="product image"
                @click="openVideoLink(lightboxImageEmbededLink)"
            />
            <i
                v-if="showFavoriteButton"
                :class="[
                    'favorite-icon',
                    favorited ? 'icon-favoritefilled' : 'icon-favorite',
                    { 'is-favorited': favorited },
                ]"
                @click="
                    favorited = !favorited;
                    emitProduct();
                "
            >
            </i>

            <div
                v-if="lightboxImageEmbededLink"
                style="
                    background-color: rgba(0, 0, 0, 0.5);
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-self: center;
                    width: 56px;
                    height: 56px;
                    transform: translate(-50%, -50%);
                    top: 50%;
                    left: 50%;
                    position: absolute;
                "
                @click="openVideoLink(lightboxImageEmbededLink)"
            >
                <i
                    class="icon-play"
                    style="color: white; font-size: 20px"
                ></i>
            </div>
        </div>

        <div class="image-lightbox-child-container">
            <div
                class="image-lightbox-child"
                v-for="(image, index) in Object.values(images)"
                :key="image.id"
            >
                <img
                    :id="image.id"
                    :class="getBorderColour(image)"
                    :src="image.source_url_small || defaultImage"
                    :alt="image.title"
                    @mouseenter="selectProduct(image)"
                    @mouseleave="hoveredImage = null"
                    @click="viewFile(index)"
                />
            </div>
        </div>

        <bo-popup-modal
            :title="name"
            :active="showViewMediaModal"
            :action="null"
            :keep-alive="true"
            @deactivate="showViewMediaModal = false"
        >
            <template #header-content>
                <slot name="header-content">
                    <div class="modal-title"></div>
                </slot>
            </template>
            <template #body-content>
                <div class="popup-container">
                    <div class="popup-image-left-panel">
                        <div
                            class="popup-image-left-btn"
                            :style="showViewMediaIndex > 1 ? { visibility: 'visible' } : { visibility: 'hidden' }"
                            @click="showViewMediaIndex--"
                        >
                            &lt;
                        </div>

                        <div class="popup-image-container">
                            <img
                                :src="images[showViewMediaIndex].source_url_medium || defaultImage"
                                alt="product image"
                                style="max-width: 640px"
                                @click="openVideoLink(images[showViewMediaIndex].embed_link)"
                            />
                            <div
                                v-if="images[showViewMediaIndex].embed_link"
                                style="
                                    background-color: rgba(0, 0, 0, 0.5);
                                    border-radius: 50%;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    align-self: center;
                                    width: 56px;
                                    height: 56px;
                                    transform: translate(-50%, -50%);
                                    top: 50%;
                                    left: 50%;
                                    position: absolute;
                                "
                                @click="openVideoLink(images[showViewMediaIndex].embed_link)"
                            >
                                <i
                                    class="icon-play"
                                    style="color: white; font-size: 20px"
                                ></i>
                            </div>
                        </div>

                        <div
                            class="popup-image-right-btn"
                            @click="showViewMediaIndex++"
                            :style="
                                showViewMediaIndex < Object.keys(images).length
                                    ? { visibility: 'visible' }
                                    : { visibility: 'hidden' }
                            "
                        >
                            &gt;
                        </div>
                    </div>

                    <div class="popup-image-right-panel">
                        <div
                            class="popup-image-right-img-child"
                            v-for="(image, index) in Object.values(images)"
                            :key="image.id"
                            :class="getImageBorder(index)"
                        >
                            <img
                                :id="image.id"
                                :src="image.source_url_small || defaultImage"
                                :alt="image.title"
                                @click="showViewMediaIndex = index + 1"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </bo-popup-modal>
        <!-- <light-box
            v-if="imageLength"
            ref="imageViewer"
            :media="lightboxImages"
            :showLightBox="showLightBox"
        ></light-box> -->
    </div>
</template>

<script>
import Vue from "vue";
import VueLazyLoad from "vue-lazyload";
import LightBox from "vue-image-lightbox";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
Vue.use(VueLazyLoad);

Vue.component("bo-popup-modal", require("@/v2/components/bo-popup-modal.vue").default);

export default {
    components: {
        LightBox,
    },

    props: {
        name: {
            type: String,
            default: "",
        },
        images: {
            type: Object,
            default: () => ({}),
        },
        lightboxImageClass: {
            type: Array,
            default: () => [],
        },
        imageGalleryClass: {
            type: Array,
            default: () => [],
        },
        showFavoriteButton: {
            type: Boolean,
            default: false,
        },
        favorite: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        imageLength: {
            get() {
                return Object.values(this.images).length;
            },
        },
        lightboxImages: {
            get() {
                return Object.values(this.images).map((image) => {
                    return {
                        thumb: image.source_url,
                        src: image.source_url,
                    };
                });
            },
        },
    },

    watch: {
        images: function (newValue, oldValue) {
            this.reloadImage();
        },
    },

    data() {
        return {
            hoveredImage: null,
            lightboxImage: null,
            lightboxImageEmbededLink: "",
            showLightBox: false,
            showViewMediaModal: false,
            showViewMediaIndex: 1,
            favorited: this.favorite,
            defaultImage: "/assets/graphics/img-product.svg",
        };
    },

    mounted() {
        this.reloadImage();
    },

    methods: {
        reloadImage() {
            this.lightboxImage = this.defaultImage;
            if (Object.values(this.images).length) {
                const image = Object.values(this.images)[0];
                console.log('reload', JSON.parse(JSON.stringify(image)));
                this.lightboxImage = Object.values(this.images)[0].source_url_medium || this.defaultImage;
                this.lightboxImageEmbededLink = Object.values(this.images)[0].embed_link;
            }
        },
        selectProduct(image) {
            this.hoveredImage = image.id;
            console.log('select', JSON.parse(JSON.stringify(image)));
            this.lightboxImage = image.source_url_medium || this.defaultImage;
            this.lightboxImageEmbededLink = image.embed_link;
        },
        getBorderColour(image) {
            return this.hoveredImage == image.id ? "active" : "";
        },
        getImageBorder(index) {
            return this.showViewMediaIndex == index + 1 ? "active" : "";
        },
        viewFile(index) {
            this.showViewMediaModal = true;
            this.showViewMediaIndex = index + 1;
            // this.$refs.imageViewer.showImage(index);
        },
        openLightbox(images) {
            this.lightboxImages = images;
            this.isLightboxOpen = true;
        },
        closeLightbox() {
            this.isLightboxOpen = false;
        },
        openVideoLink(link) {
            if (link) {
                window.open(link, "_blank");
            }
        },
        emitProduct() {
            this.$emit("favorite_product", this.favorited);
        },
    },
};
</script>
